import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserProfileComponent } from '../user-profile.component';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-account-reactivated',
  templateUrl: './account-reactivated.component.html',
  styleUrls: ['./account-reactivated.component.scss'],
})
export class AccountReactivatedComponent {
  @Input() dialogRef!: MatDialogRef<UserProfileComponent>;
  @Input() userName!: string;

  constructor(private localizationService: LocalizationService) {
    this.localizationService.setupLocalization();
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  onDone(): void {
    this.dialogRef?.close();
  }
}
